import { Map, Record, List } from 'immutable';
import { companySignInAction } from '@/domain/companies/companiesActions';
import { erpsUpdateDataAdapter } from '@/domain/settings/helpers';
import { erpsAdapter } from '@/domain/settings/adapters';
import * as A from '@/domain/settings/settingsActions';
import { settingsTypes } from '@/domain/settings/constants';

import { signOutAction } from '@/domain/env';

const InitialState = Record({
  category: null,
  params: Map(),
  erps: Map(),
  endpoint: null,
  erpType: null,
  erpSettings: List(),
  isLoadingERPSetting: false,
  hasLoadedErpSettings: false,
});

export const reducer = {
  settings(state = InitialState(), action) {
    switch (action.type) {
      case companySignInAction.request:
        // Reset ERP settings when switching companies
        return state.set('erpSettings', List()).set('isLoadingERPSetting', false).set('hasLoadedErpSettings', false);

      case A.getCategory.success:
        return state.set('category', action.payload.category).mergeIn(['erps'], action.payload.erps);

      case A.setErpsAction.type:
        return state.mergeIn(['erps'], erpsAdapter(action.payload)).set('erpSettings', List());

      case A.updateConnectionsTable.success:
        return state.mergeIn(['erps'], erpsUpdateDataAdapter(action.payload, state.erps));

      case A.getSSOParams.success:
        return state.merge(action.payload);

      case A.getCurrentERPSettings.type:
        return state.set('isLoadingERPSetting', true);

      case A.setCurrentERPSettingsAction.request:
        return state.set('isLoadingERPSetting', true);

      case A.getCurrentERPSettings.success:
      case A.setCurrentERPSettingsAction.success:
        return state
          .set('erpSettings', action.payload)
          .set('isLoadingERPSetting', false)
          .set('hasLoadedErpSettings', true);

      case A.getCurrentERPSettings.failure:
        return state.set('erpSettings', List()).set('isLoadingERPSetting', false).set('hasLoadedErpSettings', false);

      // Guarded because a mutation callback outlives the route that started it, so
      // this can arrive after the slice was cleared. In Immutable `-1` addresses the
      // last row rather than missing, so an unguarded write lands on another setting.
      case A.saveFTPConnectionAction.success: {
        const index = state.erpSettings.findIndex((item) => item.type === 'ftp_connection');

        return index === -1 ? state : state.setIn(['erpSettings', index, 'value'], action.payload);
      }

      // Saved through its own endpoint, so the value is patched in place.
      case A.savePriorityCustomerApiConnectionAction.success: {
        const index = state.erpSettings.findIndex(
          (item) => item.type === settingsTypes.priority_customer_api_connection,
        );

        return index === -1 ? state : state.setIn(['erpSettings', index, 'value'], action.payload);
      }

      case A.clearCategoryAction.success:
        return state.set('category', null).set('erps', Map());

      case A.syncErpIndexesAction.type: {
        const index = state.erpSettings.findIndex(({ type }) => type === 'indexes_sync_time');

        return index === -1 ? state : state.setIn(['erpSettings', index, 'is_sync_running'], true);
      }

      case A.syncErpIndexesAction.failure: {
        const index = state.erpSettings.findIndex(({ type }) => type === 'indexes_sync_time');

        return index === -1 ? state : state.setIn(['erpSettings', index, 'is_sync_running'], false);
      }

      case signOutAction.success:
        return InitialState();

      default:
        return state;
    }
  },
};
